import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['checkboxMember', 'checkboxLogin', 'datePickerCreated',
    'datePickerLogin', 'checkboxLMSUsers', 'datePickerTerminated', 'continueButton'];

  static values = {
    cornerstoneEnabled: Boolean
  }

  connect() {
    this.checkboxMemberTarget.addEventListener('change', this._updateStateContinueButton.bind(this));
    this.checkboxLoginTarget.addEventListener('change', this._disableDatePickerLogin.bind(this));
    this.datePickerCreatedTarget.addEventListener('change', this._updateStateContinueButton.bind(this));
    this.datePickerLoginTarget.addEventListener('change', this._disableCheckboxLogin.bind(this));
    this.continueButtonTarget.addEventListener('click', this._showSearchResults.bind(this));

    if (this.cornerstoneEnabledValue) {
      this.checkboxLMSUsersTarget.addEventListener('change', this._updateStateContinueButton.bind(this));
      this.datePickerTerminatedTarget.addEventListener('change', this._updateStateContinueButton.bind(this));
    }

    window.addEventListener('load', this._disabledLoginCriteriaOnFirstLoad.bind(this))
  }

  disconnect() {
    window.removeEventListener('load', this._disabledLoginCriteriaOnFirstLoad.bind(this))
  }

  _disabledLoginCriteriaOnFirstLoad() {
    this._disableCheckboxLogin();
    this._disableDatePickerLogin();
  }

  _disableCheckboxLogin() {
    this.checkboxLoginTarget.disabled = this.datePickerLoginTarget.value !== '';

    this._updateStateContinueButton();
  }

  _disableDatePickerLogin() {
    if (this.checkboxLoginTarget.checked) {
      this.datePickerLoginTarget.dispatchEvent(
        new CustomEvent("promote:datepicker-disable")
      );
    } else {
      this.datePickerLoginTarget.dispatchEvent(
        new CustomEvent("promote:datepicker-enable")
      );
    }

    this._updateStateContinueButton();
  }

  _updateStateContinueButton() {
    if (this._noFiltersSelected()) {
      this._setDisabledStateContinueButton(true);
    } else {
      this._setDisabledStateContinueButton(false);
    }
  }

  _setDisabledStateContinueButton(isDisabled) {
    this.continueButtonTarget.disabled = isDisabled;
  }

  _showSearchResults() {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    Rails.ajax({
      url: this._searchUrl(),
      type: "POST",
      dataType: "script",
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    });
  }

  _searchUrl() {
    const baseUrl = '/admin/bulk_user_deletions/search';
    const params = new URLSearchParams();

    if (this.checkboxMemberTarget.checked) {
      params.append(this.checkboxMemberTarget.name, 'true');
    }

    if (this.checkboxLoginTarget.checked) {
      params.append(this.checkboxLoginTarget.name, 'true');
    }

    if (this.datePickerCreatedTarget.value) {
      params.append(this.datePickerCreatedTarget.name, this.datePickerCreatedTarget.value);
    }

    if (this.datePickerLoginTarget.value) {
      params.append(this.datePickerLoginTarget.name, this.datePickerLoginTarget.value);
    }

    if (!this.cornerstoneEnabledValue) {
      return `${baseUrl}?${params.toString()}`;
    }

    if (this.checkboxLMSUsersTarget.checked) {
      params.append(this.checkboxLMSUsersTarget.name, 'true');
    }

    if (this.datePickerTerminatedTarget.value) {
      params.append(this.datePickerTerminatedTarget.name, this.datePickerTerminatedTarget.value);
    }

    return `${baseUrl}?${params.toString()}`;
  }

  _noFiltersSelected() {
    const noBaseCriteriaSelected = !this.checkboxLoginTarget.checked &&
      !this.checkboxMemberTarget.checked &&
      !this.datePickerCreatedTarget.value &&
      !this.datePickerLoginTarget.value;

    if (this.cornerstoneEnabledValue) {
      return noBaseCriteriaSelected &&
        !this.checkboxLMSUsersTarget.checked &&
        !this.datePickerTerminatedTarget.value;
    } else {
      return noBaseCriteriaSelected;
    }

  }
}
